var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye",
    transform: "translate(-1738 -279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    transform: "translate(1738 279)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ion-eye",
    "data-name": "Icon ion-eye",
    transform: "translate(1745.709 284.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M18.389,15.945A2.445,2.445,0,1,1,15.945,13.5,2.445,2.445,0,0,1,18.389,15.945Z",
    transform: "translate(-5.653 -3.083)",
    fill: "#00b26b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M19.262,12.2a12.946,12.946,0,0,0-3.792-3.84A9.6,9.6,0,0,0,10.279,6.75,9.151,9.151,0,0,0,5.532,8.129a13.914,13.914,0,0,0-4.189,4.052,1.219,1.219,0,0,0-.024,1.358,12.762,12.762,0,0,0,3.754,3.845,9.462,9.462,0,0,0,5.207,1.59,9.635,9.635,0,0,0,5.2-1.594,12.756,12.756,0,0,0,3.785-3.855,1.23,1.23,0,0,0,0-1.328Zm-8.97,4.332a3.667,3.667,0,1,1,3.667-3.667,3.667,3.667,0,0,1-3.667,3.667Z",
    fill: "#00b26b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEye);
export default __webpack_public_path__ + "static/media/ViewEye.4b7a43a51a3f668172631fc3be4006c6.svg";
export { ForwardRef as ReactComponent };